
import { Component, Watch } from 'vue-property-decorator'
import { OptionSection } from '@/interfaces/OptionSection'
import { mixins } from 'vue-class-component'
import { OptionValidator } from '@/mixins/OptionValidator'
import { useOptionStore } from '@/store/modules/options'

@Component
export default class Sections extends mixins(OptionValidator) {
  public sections: Array<OptionSection> = [
    {
      id: 100,
      name: 'Size & Configuration',
      seq: 0,
      route: { name: 'Size & Configuration' }
    }
  ]

  public optionStore = useOptionStore();

  public showMobileNav = false

  get filteredSections(): Array<OptionSection> {
    if (!this.menuItems) { return this.sections }
    const sections = this.sections.concat(this.serverSections)
    sections.sort((a, b) => a.seq - b.seq)
    return sections
  }

  get serverSections(): Array<OptionSection> {
    if (!this.menuItems) { return [] }
    return this.menuItems
      .filter(mi => mi.categories.some(c => !this.hideCategory(c)))
      .map(o => {
        return {
          id: o.id,
          name: o.name,
          route: { name: 'RoutableOptions', params: { menuItemUrl: o.code } },
          seq: o.seq
        }
      })
  }

  get selectedSection() {
    return this.filteredSections.find(s => s.route.name === this.$route.name &&
      (!s.route.params || !s.route.params.menuItemUrl || s.route.params.menuItemUrl === this.$route.params.menuItemUrl)) ?? this.sections[0]
  }

  mounted() {
    this.optionStore.loadOptions(this.model.code)
  }

  public toggleMobileSections() {
    this.showMobileNav = !this.showMobileNav
  }

  public get menuItems() {
    return this.optionStore.menuItems.filter(mi => mi.categories.some(c => c.options.some(o => !o.isHidden)))
  }

  @Watch('$route')
  routeChanged() {
    this.showMobileNav = false
  }
}
